// components/TabNavigation.js - VERSION ULTRA-NETTOYÉE
import React from 'react';

/**
 * Navigation par onglets - VERSION ULTRA-COMPACTE
 * ✅ Aucun style CSS avancé dans le JS
 * ✅ Hauteur réduite au minimum
 * ✅ Suppression pictos inutiles
 */
const TabNavigation = ({ 
  tabs = [], 
  activeTab = 'basic', 
  onTabChange = () => {}, 
  formData = { participant_ids: [] } 
}) => {
  const safeTabs = tabs || [];
  const safeFormData = formData || { participant_ids: [] };
  const safeParticipantIds = safeFormData.participant_ids || [];

  // Composant onglet ultra-compact
  const TabButton = React.memo(({ tab, active, onClick }) => (
    <button
      type="button"
      onClick={onClick}
      style={{
        // ✅ RÉDUCTION DRASTIQUE : Padding ultra-compact
        padding: 'clamp(4px, 1vw, 6px) clamp(8px, 2vw, 12px)',
        border: 'none',
        background: active 
          ? 'linear-gradient(135deg, #667eea, #764ba2)' 
          : 'transparent',
        color: active ? 'white' : '#6c757d',
        borderRadius: '8px 8px 0 0',
        cursor: 'pointer',
        fontSize: 'clamp(12px, 2vw, 14px)',
        fontWeight: active ? '600' : '500',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        // ✅ RÉDUCTION DRASTIQUE : MinHeight ultra-compact
        minHeight: '28px',
        boxShadow: active ? '0 2px 8px rgba(102, 126, 234, 0.3)' : 'none',
        whiteSpace: 'nowrap'
      }}
      onMouseEnter={(e) => {
        if (!active) {
          e.target.style.background = '#f8f9fa';
          e.target.style.color = '#495057';
        }
      }}
      onMouseLeave={(e) => {
        if (!active) {
          e.target.style.background = 'transparent';
          e.target.style.color = '#6c757d';
        }
      }}
    >
      {/* ✅ SUPPRESSION : Plus d'icône volumineuse inutile */}
      <span>
        {tab.label || 'Onglet'}
      </span>
      
      {/* Badge participants ultra-compact */}
      {tab.id === 'participants' && safeParticipantIds.length > 0 && (
        <span style={{
          background: 'rgba(255,255,255,0.3)',
          borderRadius: '8px',
          padding: '1px 4px',
          fontSize: '10px',
          fontWeight: '600',
          lineHeight: 1
        }}>
          {safeParticipantIds.length}
        </span>
      )}
    </button>
  ));

  const displayTabs = safeTabs.length > 0 ? safeTabs : [
    { id: 'basic', label: 'Informations' }
  ];

  return (
    <div style={{
      background: '#f8f9fa',
      // ✅ RÉDUCTION DRASTIQUE : Padding ultra-compact
      padding: 'clamp(2px, 0.5vw, 4px) clamp(8px, 2vw, 12px) 0',
      display: 'flex',
      gap: '2px',
      borderBottom: '1px solid #dee2e6',
      overflowX: 'auto'
    }}>
      {displayTabs.map(tab => (
        <TabButton
          key={tab.id || 'tab'}
          tab={tab}
          active={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        />
      ))}
    </div>
  );
};

export default TabNavigation;